<div class="phoneInputContainer">
  <mat-select name="countryCode" [(value)]="selectedCountry" (selectionChange)="update()">
    <mat-select-trigger>
      <mat-icon>expand_more</mat-icon>
      <span class="flag">{{selectedCountry.key | countryFlag}}</span>
      <span class="countryCode">{{selectedCountry.code}}</span>
    </mat-select-trigger>
    @if ((preferredCountries$ | async).length > 0) {
      <mat-optgroup label="{{'settings.phone.commonCountryCodes' | translate}}">
        @for (preferred of (preferredCountries$ | async); track preferred) {
          <mat-option
            [value]="countryCodeData[preferred]">
            {{countryCodeData[preferred].name}} ({{countryCodeData[preferred].code}}) {{countryCodeData[preferred].key
            | countryFlag}}
          </mat-option>
        }
      </mat-optgroup>
    }
    <mat-optgroup label="{{'settings.phone.allCountryCodes' | translate}}">
      @for (countryCode of countryCodeList; track countryCode) {
        <mat-option [value]="countryCodeData[countryCode]">
          {{countryCodeData[countryCode].name}} ({{countryCodeData[countryCode].code}})
          {{countryCodeData[countryCode].key | countryFlag}}
        </mat-option>
      }
    </mat-optgroup>
  </mat-select>
  <div caInputContainer>
    <input caInput autocomplete="tel" type="tel" id="phone" name="phone" [value]="mobileNumber" (input)="update({mobileNumber: $event.target.value})" placeholder="Mobile number"/>
  </div>
</div>
